import React, { useEffect } from 'react';
import Header from '@/components/header';
import SubscribeComponent from '@/components/Subscribe';
import { SafeAreaView } from 'react-native-safe-area-context';

export default function Subscribe() {
  return (
    <SafeAreaView style={{ width:'100%', flex: 1, margin:0, padding: 0 }}>
      <Header />
      <SubscribeComponent />
    </SafeAreaView>
  );
}